// extracted by mini-css-extract-plugin
module.exports = {"mainMenu":"Navigation_mainMenu__1Pu6F","menuList":"Navigation_menuList__2qQAl","menuItem":"Navigation_menuItem__3b7HI","menuButton":"Navigation_menuButton__2hRIT"};